<template>
  <v-main>
    <AppBar/>
    <v-layout fill-height column>
      <v-container flex-fill fluid>
        <div class="coin">
          <div class="d-flex align-center">
            <img :src="getImage('ic_coin.svg')" class="mr-2">
            <div class="d-flex flex-column">
              <span class="fs-12 mb-1 ">보유 코인</span>
              <span class="fs-16 fw-700 primary--text line-height-1">{{ amountCoin | comma }}</span>
            </div>
          </div>
          <v-btn plain class="btn-exchange" @click="moveCoinExchange">물성교환하기</v-btn>
        </div>
        <v-radio-group v-model="period" mandatory row active-class="active" hide-details="false">
          <v-radio
              v-for="n in periodValue"
              :key="n"
              :label="n"
              :value="n"
              :v-model="selectPeriod"
          ></v-radio>
        </v-radio-group>
        <div class="date">
          {{  lastDate + '~' +  firstdate}}
        </div>
        <div>
          <ul class="coin-list">
            <li class="d-flex justify-space-between align-center py-4" v-for="(item, index) in historyList"
                :key="index">
              <div class="d-flex flex-column">
                <span class="fs-16 fw-500 lightBlack--text line-height-1 mb-1" v-text="item.cdNm"></span>
                <span class="fs-12 secondary--text">{{ item.historyDt }}</span>
              </div>
              <div v-if="item.type==='01'" class="fs-16 lightBlack--text fw-500">+ {{ item.coin | comma }}C</div>
              <div v-if="item.type==='02'" class="fs-16 lightBlack--text fw-500">- {{ item.coin | comma }}C</div>
            </li>

          </ul>
        </div>
      </v-container>
    </v-layout>
  </v-main>
</template>
<script>
import store from '@/store'
import moment from "moment";

moment.locale("ko");

export default {
  data: () => ({
    period: 1,
    periodValue: ['전체', '1개월', '3개월', '6개월'],
    amountCoin: 0,
    historyList: [],
    firstdate: moment().format("YYYY.MM.DD"),
    lastDate: '',
    selectPeriod: '',
    periodCd: null
  }),
  watch: {
    async period(e) {
      switch (e) {
        case '1개월':
          this.periodCd = '01',
            this.lastDate = moment().subtract(1, 'month').format("YYYY.MM.DD")
          break;
        case '3개월':
          this.periodCd = '02'
          this.lastDate = moment().subtract(3, 'month').format("YYYY.MM.DD")
          break;
        case '6개월':
          this.periodCd = '03'
          this.lastDate = moment().subtract(6, 'month').format("YYYY.MM.DD")
          break;
        case '전체' :
          this.periodCd = null
          this.lastDate = ''
          break;
      }
      this.coinDetail();
    }
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  beforeCreated() {

  },
  mounted() {
    // this.coinDetail();
  },
  methods: {
    moveCoinExchange() {
      // this.$router.push(`/fo/coin/exchange`);
      this.$alert("지금은 준비 중이에요.<br/>조금만 기다려주세요.")
    },
    async coinDetail() {
      await store.dispatch('coinDetail', this.$_payload('so', [{
          periodCd: this.periodCd
        }]
      ))
        .then(res => {
          if (res.success) {
            // 내역 배열 초기화
            this.historyList.splice(0, this.historyList.length)

            this.amountCoin = res.data.amountCoin + 'C';

            for (let i = 0; i < res.data.coinHistoryResult.length; i++) {
                let historyDt = res.data.coinHistoryResult[i].historyDt;
                res.data.coinHistoryResult[i].historyDt = moment(historyDt).format("yyyy-MM-DD");
                this.historyList.push(res.data.coinHistoryResult[i]);

                if (i == res.data.coinHistoryResult.length-1 && this.lastDate === '') {
                  this.lastDate = moment(historyDt).format("yyyy.MM.DD");
                }
            }
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.coin {
  background: #F4F4F4;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .fs-12.mb-1 {
    color: #909090;
  }

  .btn-exchange {
    background: $color-sub;
    border-radius: 20px;
    color: $color-main;
    font-size: 12px;
    height: 30px;
  }
}

.coin-list {
  li {
    border-top: 1px solid $color-gray-3;

    &:first-child {
      border-top: none;
    }
  }
}

::v-deep.v-input--radio-group {
  margin-top: 40px;
  margin-bottom: 15px;
  padding-top: 0;

  .v-input--radio-group__input {
    .v-radio {
      margin-right: 8px;

      .v-input--selection-controls__input {
        display: none;
      }

      .v-label {
        font-size: 12px;
        color: $sub-title;
        background: $color-gray-3;
        padding: 0 10px;
        height: 22px;
        border-radius: 20px;
      }

      &.active {
        .v-label {
          background: #212529;
          color: #fff;
        }
      }
    }
  }
}

.date {
  border-top: 1px solid $color-gray-3;
  text-align: right;
  padding: 7px 0;
  color: $sub-title;
  font-size: 12px;
}
</style>
